export const emailActionData = [
  {
    name: 'sendDynamicEmail',
    label: 'Send Dynamic Email',
    args: [
      {
        name: 'emailTemplate',
        label: 'Email Template',
        type: 'dropdown',
        optionsType: 'emailTemplateApi',
        options: [],
        value: '',
      },
    ],
  },
];
